learnDashboardApp.factory('V3MyCollectionsResource', ['$resource', ($resource) ->
  $resource "", {},
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v3_my_collections_path()
])
